import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { useParams } from 'react-router-dom';
import { HttpClientProvider } from '@services/http/client/http-client-provider';
import { GetCategoriesRemoteCall } from '@services/http/remote-calls/snf-api/categories/get-categories.http-remote-call';
import ServiziSoluzioniDesktop from '@components/servizi-soluzioni/desktop/desktop';
import { useSiteData } from '../../../context/site-data-context';

export default function ServiziSoluzioni() {
  const { idservice } = useParams();
  const intl = useIntl();
  const { serviceCategories, technologyCategories } = useSiteData();
  const [payload, setPayload] = useState({
    pages: [],
    mainSectionDescriptions: {},
    mainSectionImageUrl: '',
    mainSectionDarkTheme: false,
    navbarItems: []
  });

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const httpClient = HttpClientProvider.getInstance();
      const categoriesRemoteCall = new GetCategoriesRemoteCall(idservice, intl.locale);
      const data = await httpClient.execute(categoriesRemoteCall);
      if (!cancelled) setPayload(data);
    })();
    return () => {
      cancelled = true;
    };
  }, [idservice, intl.locale]);

  return (
    <ServiziSoluzioniDesktop
      pages={payload.pages}
      mainSectionDescriptions={payload.mainSectionDescriptions}
      mainSectionImageUrl={payload.mainSectionImageUrl}
      mainSectionDarkTheme={payload.mainSectionDarkTheme}
      navbarItems={payload.navbarItems}
      serviceCategories={serviceCategories}
      technologyCategories={technologyCategories}
    />
  );
}
